import { memo, useEffect, useState } from "react";
import React from "react";
import Header from "../../header/Header";
import Footer from "../Footer";
import "./../accesibilidad/accesibilidad.scss";
import { getUrlAlcantara } from "../../../services/IndemnizacionService";
import { Link } from "react-router-dom";
import ModalMensajes from "../../modals/modalMensajes/ModalMensajes";
import ConsultaNominas from "../../modals/consultaNominas/ConsultaNominas";
import ConsultaIRPF from "../../modals/consultaIRPF/ConsultaIRPF";
import ConsultaIRPFHabi from "../../modals/consultaIRPFHabi/ConsultaIRPFHabi";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import ConstantesBD from "../../../../utils/ConstantesBD";
import { visualizarSeccionConcursos } from "../../../services/ConcursosService";

const MapaWeb = () => {
  const [user] = useLocalStorage("user", "");
  const [concursosVisible, setConcursosVisible] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (user) {
      visualizarSeccionConcursos().then((data) => {
        setConcursosVisible(data);
      })
    }

  }, [user]);

  const [show, setShow] = useState({
    nomina: false,
    irpf: false,
    irpfHabi: false
  });

  const toggleContenido = (header) => {
    const contenido = header.nextElementSibling;
    if (contenido.style.display === "block") {
      contenido.style.display = "none";
      header.style.backgroundColor = "#ffffff";
      header.style.color = "#1d873e";

    } else {
      contenido.style.display = "block";
      header.style.backgroundColor = "#1d873e";
      header.style.color = "#ffffff";

    }
  };

  const indemnizacion = () => {
    getUrlAlcantara().then((data) => {
      if (!data.toString().startsWith("Error")) {
        if (data.url !== null) {
          window.open(data.url);
        }
      } else {
        handleShow({
          mensaje: true,
          titulo: "Enlace no disponible para acceder al sistema de Alcantara",
          tipo: "tituloBorrador",
        });
      }
    });
    //handleOpen()
  };

  const handleShow = (e) => {
    setShow(e);
  };

  const handleClose = (e) => {
    setShow(false);
  };

  return (
    <>
      <Header />

      <h2 className="tituloPagina">Mapa Web</h2>
      <div className="lista-container">
        <div className="lista-item">
          <Link to={"/home"} className="enlace-caja">{user === null || user === undefined ? "Acceder" : "Inicio"}</Link>
        </div>
        {user === null || user === undefined ? null : (<>
          {user?.roles.includes(ConstantesBD.ROLES.ADMINISTRADOR) ? (
            <div className="lista-item">
              <div className="caja">
                <div
                  className="caja-header dropdown-toggle"
                  role="button"
                  tabIndex={0}
                  onClick={(e) => toggleContenido(e.currentTarget)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault(); // evita scroll al presionar espacio
                      toggleContenido(e.currentTarget);
                    }
                  }}
                >
                  Gestión
                </div>
                <div className="caja-contenido" style={{ display: "none" }}>
                  <Link to={"/admin"} className="enlace-caja">Administración</Link>
                </div>
              </div>
            </div>)
            : (<></>)}

          <div className="lista-item">
            <div className="caja">
              <div
                className="caja-header dropdown-toggle"
                role="button"
                tabIndex={0}
                onClick={(e) => toggleContenido(e.currentTarget)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault(); // evita scroll al presionar espacio
                    toggleContenido(e.currentTarget);
                  }
                }}
              >
                Mis consultas
              </div>
              <div className="caja-contenido" style={{ display: "none" }}>
                <Link
                  className="enlace-caja hover"
                  to="#"
                  onClick={() => {
                    handleShow({ nomina: true })
                  }}
                // tabIndex={open ? "0" : "-1"}
                >
                  Nómina
                </Link>
                <Link
                  className="enlace-caja hover"
                  to="#"
                  onClick={() => {
                    handleShow({ irpf: true })
                  }}
                // tabIndex={open ? "0" : "-1"}
                >
                  IRPF
                </Link>
                {/* <Link to={"/irpfHabilitado"} className="enlace-caja">Certificado IRPF por las habilitaciones</Link> */}
                <Link
                  className="enlace-caja hover"
                  to="#"
                  onClick={() => {
                    handleShow({ irpfHabi: true })
                  }}
                // tabIndex={open ? "0" : "-1"}
                >
                  Certificado IRPF por las habilitaciones
                </Link>
                <Link to={"/misActosAdmin"} className="enlace-caja">Consulta de mis actos administrativos</Link>
                {/* <Link to={"/hojaServiciosPrestados"} className="enlace-caja">Mi hoja de servicios prestados</Link>*/}
              </div>
            </div>
          </div>
          <div className="lista-item">
            <div className="caja">
              <div
                className="caja-header dropdown-toggle"
                role="button"
                tabIndex={0}
                onClick={(e) => toggleContenido(e.currentTarget)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault(); // evita scroll al presionar espacio
                    toggleContenido(e.currentTarget);
                  }
                }}
              >
                Mis trámites
              </div>

              <div className="caja-contenido" style={{ display: "none" }}>
                <Link to="#" className="enlace-caja" onClick={indemnizacion} >C.S Indemnización razón servicio D.287/2007</Link>

                {/* <a href="/variacionDatosPersonales" className="enlace-caja">Variación de datos personales</a>
              <a href="/carrera" className="enlace-caja">Recon. de nivel de carrera</a> */}
                <Link to={"/listadoactos"} className="enlace-caja">Trámites</Link>
              </div>
            </div>
          </div>
          {concursosVisible ? (

            <div className="lista-item">
              <div className="caja">
                <div
                  className="caja-header dropdown-toggle"
                  role="button"
                  tabIndex={0}
                  onClick={(e) => toggleContenido(e.currentTarget)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault(); // evita scroll al presionar espacio
                      toggleContenido(e.currentTarget);
                    }
                  }}
                >
                  Mis convocatorias
                </div>
                <div className="caja-contenido" style={{ display: "none" }}>
                  <Link to={"/concursos"} className="enlace-caja">Concursos de traslado</Link>
                </div>
              </div>
            </div>

          ) : null}

        </>)}
      </div>
      {show.nomina ? (
        <ConsultaNominas
          show={show}
          handleClose={handleClose}
        ></ConsultaNominas>
      ) : null}
      {show.irpf ? (
        <ConsultaIRPF show={show} handleClose={handleClose}></ConsultaIRPF>
      ) : null}

      {show.irpfHabi ? (
        <ConsultaIRPFHabi show={show} handleClose={handleClose}></ConsultaIRPFHabi>
      ) : null}
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.titulo}
          aviso={show?.aviso}
          tipo={show?.tipo}
          destinoAviso={show?.destinoAviso}
          destinoCerrar={"/mapaWeb"}
        ></ModalMensajes>
      ) : null}
      <Footer />
    </>
  );
};

export default memo(MapaWeb);